var AnchorPlugin = {
  install: function install(app) {
    app.directive('anchor', {
      created: function created(el, binding) {
        var value = binding.value;
        var id = value.id,
          title = value.title,
          order = value.order;
        el.id = id;
        el.setAttribute('anchor-id', id);
        el.setAttribute('anchor-title', title);
        el.setAttribute('anchor-order', order + '');
      },
      mounted: function mounted(el, binding) {
        var value = binding.value;
        window.dispatchEvent(new CustomEvent('anchor:update', {
          detail: value
        }));
      },
      beforeUpdate: function beforeUpdate(el, binding) {
        var value = binding.value;
        var id = value.id,
          title = value.title,
          order = value.order;
        el.id = id;
        el.setAttribute('anchor-id', id);
        el.setAttribute('anchor-title', title);
        el.setAttribute('anchor-order', order + '');
      },
      updated: function updated(el, binding) {
        var value = binding.value;
        window.dispatchEvent(new CustomEvent('anchor:update', {
          detail: value
        }));
      },
      unmounted: function unmounted(el, binding) {
        var value = binding.value;
        window.dispatchEvent(new CustomEvent('anchor:update', {
          detail: value
        }));
      }
    });
  }
};
export default AnchorPlugin;